import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import Measure from 'react-measure'
import { AnimatePresence } from "framer-motion"

import { ListTile, TextField, Paper, PopOut, Animation, ColorPicker } from 'components'
import { DeleteDialogue } from 'features'
import { FaCheck, FaTrashAlt } from 'react-icons/fa'

import { tagContext } from 'context'
import * as actionCreators from 'store/actions'
import classes from './TagOptions.module.css'

const ColorPreview = styled.div`
    background-color: ${props => props.color};
    width: 1rem;
    height: 1rem;
    margin: 0.2rem;
    border-radius: 5px;
`

const Container = styled.div`
    border-radius: 5px;
    background-color: var(--secondary-color);
    font-size: var(--popout-font-size);
    overflow: hidden;
    width: fit-content;
    /* min-width: var(--popout-width); */
    /* max-width: 17rem; */
`

class TagOptions extends Component {
    constructor(props){
        super(props);
        this.state = {
            tag: this.props.tag,
            valid: false,
            page: null,
            boundingRect: null
        }
    }

    static getDerivedStateFromProps(props, state) {
        if(props.tag){
            state.color = props.tag.color
        }
        return state
    }

    // Textfield handlers
    onSubmitHandler = () => {
        if(this.state.valid){
            this.props.updateTag(this.state.tag, this.props.data)
        }
        this.resetHandler()
        this.props.closeHandler && this.props.closeHandler()
    }

    resetHandler = () => {
        this.setState({
            valid: false,
        })
    }

    onKeyPressHandler = (event) => {
        if (event.charCode === 13) {
            this.onSubmitHandler();
        } 
    }

    onInputHandler = (event) => {
        let updatedTag = {...this.state.tag}
        updatedTag['content'] = event.target.value
        this.setState({
            tag: updatedTag,
            valid: event.target.value.length > 0 ? true : false
        })
    }

    onSelectColor = (color) => {
        let updatedTag = {...this.props.tag}
        updatedTag.color = color
        this.props.updateTag(updatedTag, this.props.data)
    }

    render() {
        const tagRef = tagContext[this.props.user ? this.props.user.theme : 'Dark']
        let renderElements = <ColorPicker inline color={this.props.tag.color} colors={tagRef} onChange={this.onSelectColor} 
                                style={{backgroundColor:'transparent', textBorderColor:'var(--secondary-accent-color)'}}/>

        
        let content = null
        switch (this.state.page){
            case 'delete':
                content = 
                    <Animation boundingRect={this.state.boundingRect} animation='slideLeft'>
                        <DeleteDialogue 
                            onDelete={() => {
                                this.props.deleteTag(this.props.tagID, this.props.data)
                                this.props.closeHandler && this.props.closeHandler()
                            }}
                            closeHandler={() => {this.setState({page: 'main'})}}
                            closeHandler2={() => {this.props.closeHandler && this.props.closeHandler()}}/>
                    </Animation>
                
                break
            case 'main':
                content =
                <AnimatePresence>
                    <Animation boundingRect={this.state.boundingRect} animation='exitRight'>
                        <div className={classes.TagOptions}>
                            <div className={classes.Header}>
                                <TextField type='single'
                                    value={this.state.tag['content']}
                                    onChange={this.onInputHandler} 
                                    onKeyPress={this.onKeyPressHandler}/>
                            </div>
                            <ListTile icon={<FaTrashAlt/>} text='Delete' onSelect={()=> {this.setState({page:'delete'})}}/>
                            <div className={classes.Title}/>
                            {renderElements}
                        </div>
                    </Animation>
                </AnimatePresence>
                break
            default:
                content =
                <AnimatePresence>
                    <Animation boundingRect={this.state.boundingRect}>
                        <div className={classes.TagOptions}>
                            <div className={classes.Header}>
                                <TextField type='single' size={1}
                                    focus
                                    // focus={this.props.inputID === `${this.props.tagID}_TagOptions`} 
                                    value={this.state.tag['content']}
                                    onChange={this.onInputHandler} 
                                    onKeyPress={this.onKeyPressHandler}/>
                            </div>
                            <ListTile icon={<FaTrashAlt/>} text='Delete' onSelect={()=> {this.setState({page:'delete'})}}/>
                            <div className={classes.Title}/>                            
                            {renderElements}
                        </div>
                    </Animation>
                </AnimatePresence>
        }

        return(
            <Paper margin='0.5rem 0'>
                <Container>
                    <Measure
                        bounds
                        onResize={contentRect => {
                            this.setState({ boundingRect: contentRect.bounds })
                        }}>
                        {({ measureRef }) => (
                            <div ref={measureRef}>{content}</div>
                        )}
                    </Measure>
                </Container>
            </Paper>
            
        )
    }
}

const mapStateToProps = state => {
    return {
        uid: state.auth.uid,
        user: state.auth.user,
        // data: state.db.data,
        data: state.db.present.data && state.db.present.data.toJS(),
        inputID: state.content.inputID,
        activePageID: state.auth.activePageID,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        updateTag: (tag, data) => dispatch(actionCreators.updateTag(tag, data)),
        deleteTag: (tagID, data) => dispatch(actionCreators.deleteTag(tagID, data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TagOptions);